<template>
  <section>
    <div v-for="(c, i) in calendarBox" :key="i">
      <main class="calendar">
        <div class="text-muted">Ня</div>
        <div class="font-weight-bold">Да</div>
        <div class="font-weight-bold">Мя</div>
        <div class="font-weight-bold">Лх</div>
        <div class="font-weight-bold">Пү</div>
        <div class="font-weight-bold">Ба</div>
        <div class="text-muted">Бя</div>

        <div
          v-for="(day, index) in c.days"
          :key="index"
          :style="{ gridColumn: column(index, i) }"
          :class="{ 'bg-secondary lms-calendar-today tx-white': today(day) }"
        >
          {{ day.format("D") }}
        </div>
      </main>
    </div>

    <!-- <vc-calendar :attributes="dots" locale="mn" /> -->
  </section>
</template>

<script>
const moment = require("moment");
export default {
  data() {
    return {
      calendarBox: [],
      monthStart: 0,

      logData: {
        inTime: "",
        liog: [],
        months: [],
        outTime: ""
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let self = this;
      self.calendarBox = [];
      for (var i = self.monthStart; i < self.monthStart + 1; i++) {
        //let md = moment(new Date().setMonth(new Date().getMonth() + i)).startOf("month");
        let md = moment(new Date())
          .add(i, "month")
          .startOf("month");
        //console.log(formatDateYM(md, 'оны ')+'-р сар');
        //console.log(md)

        self.calendarBox.push({
          title: md,
          days: [...Array(md.daysInMonth())].map((_, i) =>
            md.clone().add(i, "day")
          )
        });
      }
    },
    column(index, i) {
      if (index == 0) {
        return this.calendarBox[i].days[0].day() + 1;
      }
    },
    today(day) {
      return moment().isSame(day, "day");
    },
    getTime(flag, date) {
      let rv = "";
      let rrr = "";
      if (this.logData.log != undefined && this.logData.log.length > 0) {
        rrr = this.logData.log[0].logTime.filter(
          x =>
            x.time != null &&
            x.flag == flag &&
            moment(x.time, "YYYY/MM/DD").isSame(moment(date, "YYYY/MM/DD"))
        );
        if (rrr.length > 0) {
          if (rrr[0].type == null || rrr[0].type == "")
            rv = rrr[0].timeSpan.substring(0, 5);
          else if (flag == 2) rv = rrr[0].type;
        }
      }
      return rv;
    }
  },
  computed: {
    dots() {
      return [
        {
          dot: "red",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 1),
            new Date(this.thisMonthYear, this.thisMonth, 10),
            new Date(this.thisMonthYear, this.thisMonth, 22),
            new Date(this.nextMonthYear, this.nextMonth, 6),
            new Date(this.nextMonthYear, this.nextMonth, 16)
          ]
        },
        {
          dot: "teal",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 4),
            new Date(this.thisMonthYear, this.thisMonth, 10),
            new Date(this.thisMonthYear, this.thisMonth, 15),
            new Date(this.nextMonthYear, this.nextMonth, 1),
            new Date(this.nextMonthYear, this.nextMonth, 12),
            {
              start: new Date(this.nextMonthYear, this.nextMonth, 20),
              end: new Date(this.nextMonthYear, this.nextMonth, 25)
            }
          ]
        },
        {
          dot: "blue",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 12),
            new Date(this.thisMonthYear, this.thisMonth, 26),
            new Date(this.thisMonthYear, this.thisMonth, 15),
            new Date(this.nextMonthYear, this.nextMonth, 9),
            new Date(this.nextMonthYear, this.nextMonth, 5),
            new Date(this.nextMonthYear, this.nextMonth, 6),
            new Date(this.nextMonthYear, this.nextMonth, 20),
            new Date(this.nextMonthYear, this.nextMonth, 25)
          ]
        }
      ];
    }
  }
};
</script>

<style scoped>
.m-calendar {
  background: #fff;
  padding: 0;
}
.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  max-width: 100vw;
  width: 100%;
}

.calendar > * {
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  height: 35px;
}

.calendar > *::before {
  content: "";
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 1px;
}

.calendar > *.today {
  background-color: hsl(241deg 100% 79%) !important;
  color: white;
  /* border: 0.1em solid rgba(0, 0, 0, 0.2); */
  border-radius: 100%;
}

.calendar > *.active {
  border-radius: 100%;
  background: rgb(43, 175, 180);
  color: #fff;
}
</style>
